<template>
  <AppBanner>
    Edit Setting
  </AppBanner>

  <template v-if="loading">
    <AppContentLoader
      :is-loading="loading"
      text="Loading setting..."
    />
  </template>

  <template v-else-if="!setting">
    <h1 class="mt-5 flex items-center justify-center h-full">
      Unable to load setting. Please try again.
    </h1>
  </template>

  <template v-else>
    <SettingForm :model="setting" />
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppContentLoader } from '@/components/app';
import { AppBanner } from '@/components/banners';
import { SettingForm } from '@/components/forms';

import { useHttp } from '@/composables';

const route = useRoute();

const loading = ref(true);
const setting = ref(null);

onMounted(async () => {
  await loadSetting();
});

const loadSetting = async () => {
  const response = await useHttp().get(`/settings/${route.params.setting}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    setting.value = response.data;
  }

  loading.value = false;
};
</script>
